import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import ICON_PROMOTION_LABEL from '../images/icon-promotion-label.png';
import { getImageSrc } from '../utils/get-image-src';
export var PromotionLabel = function PromotionLabel(_ref) {
  var className = _ref.className,
    promotion = _ref.promotion,
    imgSrc = _ref.imgSrc;
  return _jsx(_Fragment, {
    children: promotion && _jsx("div", Object.assign({
      className: classNames(className)
    }, {
      children: _jsxs("div", Object.assign({
        className: classNames('relative')
      }, {
        children: [_jsx("img", {
          src: getImageSrc(imgSrc !== null && imgSrc !== void 0 ? imgSrc : ICON_PROMOTION_LABEL),
          className: classNames('w-full h-full')
        }), _jsx("p", Object.assign({
          className: classNames('text-xs text-black-1 absolute top-0 w-full h-full flex justify-center items-center')
        }, {
          children: promotion
        }))]
      }))
    }))
  });
};